import Q2 from './Q2';

export default Q2;
